import SignalPackagesTabs from "./components/signalPackagesTabs";

export default function SignalPackages() {

    return (
        <div>
            <SignalPackagesTabs />
        </div>
    )
}